import React, { useState, useEffect, useRef } from 'react';
import Moment from 'react-moment';
import 'moment/locale/de';
import { useDispatch, useSelector} from 'react-redux';
import { setActiveTab } from '../../actions/wetterAction';
import {MODIMAGEPATH} from '../api';

function MiddleSection(props) {
    const dispatch = useDispatch();
    const active_tab = useSelector((store)=>store.wetter.active_tab);
    const wdata = useSelector((store)=>store.wetter[active_tab]);

    const accordionItem = useRef([]);

    const showAccordion = (index) => {
        Object.keys(accordionItem.current).forEach((v)=>{
            if(parseInt(v)!==parseInt(index)){
                accordionItem.current[v].classList.remove('active');
            }
        })
        accordionItem.current[index].classList.toggle('active');
    }
    return (
        <div className='wa_container'>
            <div className='tbdiv'>
                <div className='archead'>
                    <div className="arcarea">
                        <div className="ttlhead"></div>
                        <div className="ttlmxmn">max./min.°C</div>
                        <div className="ttlkm"><img src={MODIMAGEPATH + 'windy.png'} alt='' /> km/h</div>
                        <div className="ttlcm">
                            <div className="ttlcmone">
                                <img src={MODIMAGEPATH + 'drop.png'} alt='' />
                                <span>l/m²</span>
                            </div>
                            <div className="ttlcmone">
                                <img src={MODIMAGEPATH + 'snowflake.png'} alt='' />
                                <span>cm</span>
                            </div>
                        </div>                        
                        <div className="ttlhm"><img src={MODIMAGEPATH + 'sun.png'} alt='' /> h min.</div>
                    </div>
                </div>
                <div className='accordianarea'>
                {    
                wdata.multiday_wdata !== null && Object.values(wdata?.multiday_wdata?.Forecast_daily?.ForecastTimes_LocalTime).slice(0,parseInt(props.daynumber)).map((time,index)=>{
                    var iconsvghead = MODIMAGEPATH + 'svg/' + wdata?.multiday_wdata?.Forecast_daily?.Icon[index].replace('.png', '.svg');
                    var checkarrow = index < Object.values(wdata?.multiday_wdata?.Forecast_daily?.ForecastTimes_LocalTime).length - 2 ? 1 : 0;
                    return (
                        <div ref={(el) => accordionItem.current[index] = el} key={index} className="arcitem">
                            <div className="arcarea">
                                <div className="ttlhead">
                                    <h6 className="showmobile"><Moment format='dd' locale={props.lang}>{time}</Moment></h6>
                                    <h6 className="showdesktop"><Moment format='dddd' locale={props.lang}>{time}</Moment></h6>

                                    <span><Moment format='DD.MM'>{time}</Moment></span>
                                </div>
                                
                                <div className="ttlmxmn">
                                    <img id={'tal_'+index} src={iconsvghead} alt="" />
                                    <p>
                                        {wdata?.multiday_wdata?.Forecast_daily?.TemperatureMinimum[index]}° / {wdata?.multiday_wdata?.Forecast_daily?.TemperatureMaximum[index]}°
                                    <span>
                                        {props.lang === 'de' ? 'gefühlt' : 'Felt'} {wdata?.multiday_wdata?.Forecast_daily?.FeltTemperatureMinimum[index]}° / {wdata?.multiday_wdata?.Forecast_daily?.FeltTemperatureMaximum[index]}°
                                    </span>
                                    </p>
                                </div>
                                <div className="ttlkm">
                                    <p>
                                    {wdata?.multiday_wdata?.Forecast_daily?.WindSpeed[index]} km/h 
                                        <span>
                                            {wdata?.multiday_wdata?.Forecast_daily?.WindDirection[index]}
                                        </span>
                                    </p>
                                </div>
                                <div className="ttlcm">
                                    <p>
                                        <img src={MODIMAGEPATH+'drop.png'} alt='' />
                                        {wdata?.multiday_wdata?.Forecast_daily?.PrecipitationRain_dailySum[index]} l/m²
                                    </p>
                                    <p>
                                        <img src={MODIMAGEPATH+'snowflake.png'} alt='' />
                                        {wdata?.multiday_wdata?.Forecast_daily?.PrecipitationSnow_dailySum[index]} cm
                                        <span>{wdata?.multiday_wdata?.Forecast_daily?.TotalCloudCoverMaximum[index]}%</span>
                                    </p>
                                </div>
                                <div className="ttlhm">
                                    <p>{wdata?.multiday_wdata?.Forecast_daily?.SunshineDuration_dailySum[index]} h</p>
                                </div>
                                {
                                    checkarrow ?
                                    <div className="arwn" onClick={()=>showAccordion(index)}>
                                        <img src={MODIMAGEPATH + 'arrow.png'} alt='' />
                                    </div>
                                    :''
                                }

                            </div>
                            <div className="arcdetails">
                            {
                                index < 4 ?   
                                wdata?.multiday_wdata?.Forecast_hourly?.ForecastTimes_LocalTime?.map((day_time, day_time_key)=>{
                                    var datetime = day_time ? day_time.split('T') : [];
                                    if(time === datetime[0]){
                                    //if(time === moment(day_time).format("yyyy-MM-DD")){
                                        var timehh_mm = (typeof datetime[1] !== 'undefined') ? datetime[1].split('+')[0] : ''; 
                                        var iconhour = MODIMAGEPATH + "svg/" + wdata?.multiday_wdata?.Forecast_hourly?.Icon[day_time_key].replace(".png", ".svg");                                   
                                        return (
                                            <div key={'day_time_key'+day_time_key} className="arcarea">
                                                <div className="ttlhead">
                                                    <h6>{timehh_mm}</h6>
                                                </div>
                                                <div className="ttlmxmn">
                                                    <img src={iconhour} alt="" />
                                                    <p>
                                                        {wdata?.multiday_wdata?.Forecast_hourly?.Temperature[day_time_key]}°
                                                        <span>
                                                            {wdata?.multiday_wdata?.Forecast_hourly?.FeltTemperature[day_time_key]}°
                                                        </span>
                                                    </p>
                                                </div>
                                                <div className="ttlkm">
                                                    <p>
                                                        {wdata?.multiday_wdata?.Forecast_hourly?.WindSpeed[day_time_key]} km/h 
                                                        <span>
                                                            {wdata?.multiday_wdata?.Forecast_hourly?.WindDirection[day_time_key]}
                                                        </span>
                                                    </p>
                                                </div>
                                                <div className="ttlcm">
                                                    <p>
                                                        <img src={MODIMAGEPATH + "drop.png"} alt="" />  
                                                        {wdata?.multiday_wdata?.Forecast_hourly?.PrecipitationRain_hourlySum[day_time_key]} l/m²
                                                    </p>
                                                    <p>
                                                        <img src={MODIMAGEPATH + "snowflake.png"} alt="" /> 
                                                        {wdata?.multiday_wdata?.Forecast_hourly?.PrecipitationSnow_hourlySum[day_time_key]} cm 
                                                        <span>{wdata?.multiday_wdata?.Forecast_hourly?.TotalCloudCover[day_time_key]}%</span>
                                                    </p>
                                                </div>
                                                <div className="ttlhm">
                                                    <p>{wdata?.multiday_wdata?.Forecast_hourly?.SunshineDuration_hourlySum[day_time_key]} h</p>
                                                </div>
                                            </div>
                                        )
                                    }
                                })                                
                                : 
                                //go with 3 hours forecast after 4 days of hourly forecast
                                wdata?.multiday_wdata?.Forecast_3hourly?.ForecastTimes_LocalTime?.map((day_time, day_time_key)=>{
                                    var datetime = day_time ? day_time.split('T') : [];
                                    if(time === datetime[0]){
                                    //if(time === moment(day_time).format("yyyy-MM-DD")){
                                        var timehh_mm = (typeof datetime[1] !== 'undefined') ? datetime[1].split('+')[0] : ''; 
                                        var iconhour = MODIMAGEPATH + "svg/" + wdata?.multiday_wdata?.Forecast_3hourly?.Icon[day_time_key].replace(".png", ".svg");                                   
                                        return (
                                            <div key={'day_time_key'+day_time_key} className="arcarea">
                                                <div className="ttlhead">
                                                    <h6>{timehh_mm}</h6>
                                                </div>
                                                <div className="ttlmxmn">
                                                    <img src={iconhour} alt="" />
                                                    <p>
                                                        {wdata?.multiday_wdata?.Forecast_3hourly?.Temperature[day_time_key]}°
                                                        <span>
                                                            {wdata?.multiday_wdata?.Forecast_3hourly?.FeltTemperature[day_time_key]}°
                                                        </span>
                                                    </p>
                                                </div>
                                                <div className="ttlkm">
                                                    <p>
                                                        {wdata?.multiday_wdata?.Forecast_3hourly?.WindSpeed[day_time_key]} km/h 
                                                        <span>
                                                            {wdata?.multiday_wdata?.Forecast_3hourly?.WindDirection[day_time_key]}
                                                        </span>
                                                    </p>
                                                </div>
                                                <div className="ttlcm">
                                                    <p>
                                                        <img src={MODIMAGEPATH + "drop.png"} alt="" />  
                                                        {wdata?.multiday_wdata?.Forecast_3hourly?.PrecipitationRain_3hourlySum[day_time_key]} l/m²
                                                    </p>
                                                    <p>
                                                        <img src={MODIMAGEPATH + "snowflake.png"} alt="" /> 
                                                        {wdata?.multiday_wdata?.Forecast_3hourly?.PrecipitationSnow_3hourlySum[day_time_key]} cm 
                                                        <span>{wdata?.multiday_wdata?.Forecast_3hourly?.TotalCloudCover[day_time_key]}%</span>
                                                    </p>
                                                </div>
                                                <div className="ttlhm">
                                                    <p>{wdata?.multiday_wdata?.Forecast_3hourly?.SunshineDuration_3hourlySum[day_time_key]} h</p>
                                                </div>
                                            </div>
                                        )
                                    }
                                })
                            }
                            </div>
                        </div>  
                    )
                })
                }
                </div>
            </div>
        </div>
    );
}

export default MiddleSection;